import { environment } from './../../../../environments/environment';
import { Autos, AutosCamara } from './../../../_entities/autos/Autos';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '../../auth/auth.service';
import { ReporteCombustibleHistorico } from '../../../_entities/vehiculos/ReporteCombustibleHistorico';

@Injectable({
	providedIn: 'root'
})
export class VehiculosService {

	constructor(private http: HttpClient,
		private auth: AuthService) { }

	obtenerAutos(): Observable<Autos[]> {
	/*	let user = this.auth.getUser();
		let token = '0'
		if(user.permisos.includes('140')) {
			token = token1
		}*/

		return this.http.get<Autos[]>(`${environment.API_SECURITY}/api/vehiculo/UltimaVehiculos`);
	}

	obtenerAlertas(): Observable<Autos[]> {
		/*let user = this.auth.getUser();
		let token = '0'
		if(user.permisos.includes('140')) {
			token = token1
		}*/
		return this.http.get<Autos[]>(`${environment.API_SECURITY}/api/vehiculo`
		);
	}

	obtenerAutosCamara( pageNum, pageCount, beginTime, endTime, deviceID): Observable<any> {
		return this.http.get<any>(environment.API_SECURITY + '/api/Howen/device', {
			params: {
				pageNum,
				pageCount,
				beginTime,
				endTime,
				deviceID
			}
		})
	}

	obtenerUltimaPosicionAutosCamara(pageNum, pageCount, keyword = '') {
		return this.http.get(environment.API_SECURITY + '/api/Howen/UltimaPosicion', {
			params: {
				pageNum,
				pageCount,
				keyword,
			}
		})
	}

	getReporteHistorico(idVehiculo: number, fechaInicio, fechaFinal): Observable<any> {
		return this.http.get<any>(`${environment.API_SECURITY}/api/vehiculo/${idVehiculo}/reporte-historico-web?fechaInicio=${fechaInicio}&fechaFinal=${fechaFinal}`);
	}

	getNotificaciones () {
		return this.http.get(environment.API_SECURITY + '/api/notificaciones');
	}

	getReporteHistoricoCombustible(idVehiculo:number,fechaInicio,fechaFinal):Observable<ReporteCombustibleHistorico[]>{
		return this.http.get<ReporteCombustibleHistorico[]>(`${environment.API_SECURITY}/api/vehiculo/${idVehiculo}/reporte-historico-combustible?fechaInicio=${fechaInicio}&fechaFinal=${fechaFinal}`);

	}
}
